import { recoverEnergy } from "./energy";
import type { GameState } from "./types";

/** Display only. The server still validates every tap/refill and owns energy. */
export function energyPresentation(state: GameState, serverNow: string, pendingTaps: number, costPerTap: number) {
  const recovered = recoverEnergy({
    ...state.energy,
    lastEnergyAt: state.meta.lastEnergyAt,
    remainderMilliseconds: state.meta.energyRemainderMilliseconds,
    boosts: state.premium?.energyRecoveryBoosts ?? [],
  }, new Date(state.season.status === "active"
    ? Math.min(Date.parse(serverNow), Date.parse(state.season.endsAt))
    : Date.parse(state.meta.lastEnergyAt)));
  return { ...recovered, current: Math.max(0, recovered.current - Math.max(0, pendingTaps) * costPerTap) };
}
